import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../../shared/styles/vars';
import { media } from '../../../shared/styles/constants';

export const styles = StyleSheet.create({
	title: {
		fontSize: '18px',
		fontWeight: fontWeight.normal,
		letterSpacing: '6.5px',
		marginBottom: '26px',
		textTransform: 'uppercase',

		[media.MOBILE]: {
			marginLeft: '10px',
			marginBottom: '17px',
			fontSize: '13px'
		}
	},

	header: {
		width: '100%',
		display: 'inline-flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},

	collectionWrapper: {
		position: 'relative',
		marginBottom: '20px',
		height: '720px',

		[media.TABLET]: {
			height: '620px',
		},

		[media.MOBILE]: {
			height: '461px',
		}

	},

	footer: {
		width: '100%',
		display: 'inline-flex',
		justifyContent: 'center',
		alignItems: 'center',

		[media.MOBILE]: {
			marginBottom: '25px'
		}
	},

	moreLink: {
		fontSize: '12px',
		fontWeight: fontWeight.bold,
		color: color.blue,
		textDecoration: 'none',

		':hover': {
			color: color.darkBlue
		}
	},

	moreLinkHeader: {
		[media.MOBILE]: {
			display: 'none'
		}
	},

	moreLinkFooter: {
		[media.AT_LEAST_TABLET]: {
			display: 'none'
		}
	},

	container: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		marginBottom: '20px',
		alignItems: 'flex-start',

		[media.MOBILE]: {
			justifyContent: 'space-around',
			marginBottom: '0'
		}
	},

	vcWrapper: {
		[media.MOBILE]: { 
			width: '100%',
			overflowX: 'auto',
			height: 'auto',
			'-webkit-overflow-scrolling': 'touch'
		}
	},

	containerVC: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		marginBottom: '20px',
		alignItems: 'flex-start',

		[media.MOBILE]: {
			justifyContent: 'space-between',
			marginBottom: '0',
			height: 'auto',
			overflowX: 'auto',
			display: 'inline-flex',
			padding: '0 5px',
			flexWrap: 'nowrap',
			alignItems: 'normal'
		}
	},

	showContainer: {
		width: '100%',
		height: '100%'
	},

	showDetails: {
		[media.MOBILE]: {
			padding: '0 10px',
		}
	},

	showImageCont: {
		width: '1280px',
		position: 'absolute',
		zIndex: '-1',
		marginLeft: '-50px',
		backgroundColor: color.black,

		[media.LAPTOP]: {
			width: '100vw',
			height: '700px',
			marginLeft: 'calc(-50vw + 50%)',
		},

		[media.TABLET]: {
			width: '100vw',
			height: '100%',
			marginLeft: 'calc(-50vw + 50%)',
		},

		[media.MOBILE]: {
			width: '100%',
			marginLeft: '0px',
			height: '80%',
		} 
	},

	imageWrapper: {	
		position: 'relative'
	},

	showOverlay: {
		position: 'absolute',
		width: '100%',
		height: '60%',
		top: '40%',
		backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.0), #000000)',

		[media.MOBILE]: {
			width: '100%',
		}
	},

	showImage: {
		width: '100%',
		display: 'block',

		':after' :{
			backgroundImage: 'linear-gradient(to bottom, transparent 0%, white 100%)'
		},

		[media.MOBILE]: {
			width: '100%',
			height: 'auto'
		}

	},

	showVCContainer: {
		position: 'relative',
		height: '100%',
		paddingTop: '30px'
	},

	divider: {
		height: '1px',
		opacity: '0.2',
		backgroundColor: '#ffffff',
		display: 'block',
		marginBottom: '30px',

		[media.MOBILE]: {
			marginBottom: '20px'
		}
	},

	showLogo: {
		width: '250px',
		marginBottom: '22px',
		
		[media.TABLET]: {
			width: '210px',
		},

		[media.MOBILE]: {
			width: '120px',
			marginBottom: '13px',
		}

	},

	showLogoImg: {
		width: '100%',
		height: '100%'
	},

	logoLink: {
		display: 'block',
		width: '100%',
		height: '100%',
	}, 

	airTime: {
		display: 'block',
		fontSize: '17px',
		fontWeight: 'bold',
		lineHeight: '0.94',
		textAlign: 'left',
		color: '#ffffff',
		marginBottom: '40px',

		[media.MOBILE]: {
			fontSize: '11px',
			lineHeight: '1.45',
			marginBottom: '17px',
		}


	},

	moreBtnBg: {
		height:'40px',
		borderRadius: '4px',
		backgroundColor: color.white,
		display: 'inline-flex',
		textDecoration: 'none',
		marginBottom: '50px',

		[media.MOBILE]: {
			marginBottom: '20px',
		}
		
	},

	moreBtnText: {
		fontSize: '12px',
		fontWeight: 'bold',
		textAlign: 'left',
		color:'#000000',
		margin: 'auto 20px',
		textDecoration: 'none',
		cursor: 'inherit'

	}
	
});


// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/styles/videoCollectionStyles.js